// extracted by mini-css-extract-plugin
export var details = "_ko-0";
export var inspectorPopover = "_ko-1";